var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from "@material-ui/core/styles";
export var createMuiChipOverrides = function (_a) {
    var spacing = _a.spacing, shape = _a.shape, palette = _a.palette, typography = _a.typography;
    var baseBackground = palette.type === "dark" ? palette.common.white : palette.common.offBlack;
    return {
        root: __assign(__assign({}, typography.caption), { height: spacing(6), borderRadius: shape.borderRadius, color: palette.text.primary, 
            // Contrast level 2
            backgroundColor: alpha(baseBackground, 0.16) }),
        sizeSmall: {
            height: spacing(4),
        },
        label: {
            paddingLeft: spacing(2),
            paddingRight: spacing(2),
        },
        labelSmall: {
            paddingLeft: spacing(1),
            paddingRight: spacing(1),
        },
        icon: {
            color: "inherit",
            marginLeft: spacing(1),
            marginRight: spacing(-1),
            // Icons in chips are 20x20 in size, but with an 16x16 drawing area
            fontSize: typography.pxToRem(20),
            padding: 2,
        },
        iconSmall: {
            width: undefined,
            height: undefined,
            marginLeft: undefined,
            marginRight: 0,
        },
        clickable: {
            "&:hover, &:focus": {
                backgroundColor: alpha(baseBackground, 0.16 + palette.action.hoverOpacity // Contrast level 2 + hover
                ),
            },
            "&:focus": {
                boxShadow: "inset 0 0 0 1px ".concat(palette.text.primary),
            },
            "&:active": {
                boxShadow: undefined,
                backgroundColor: alpha(baseBackground, 0.16 + palette.action.activatedOpacity // Contrast level 2 + active
                ),
            },
        },
        deletable: {
            "&:focus": {
                backgroundColor: alpha(baseBackground, 0.16 + palette.action.hoverOpacity // Contrast level 2 + hover
                ),
                boxShadow: "inset 0 0 0 1px ".concat(palette.text.primary),
            },
        },
        deleteIcon: {
            color: "inherit",
            borderRadius: shape.borderRadius,
            margin: spacing(0, 1, 0, -1),
            width: undefined,
            height: undefined,
            // Icons in chips are 20x20 in size, but with an 16x16 drawing area
            fontSize: typography.pxToRem(20),
            padding: 2,
            "&:hover": {
                color: undefined,
                backgroundColor: palette.action.hover,
            },
            "&:active": {
                backgroundColor: palette.action.active,
            },
        },
        deleteIconSmall: {
            width: undefined,
            height: undefined,
            marginRight: 0,
            marginLeft: 0,
        },
    };
};
//# sourceMappingURL=MuiChip.js.map